module.exports = __webpack_public_path__ + "static/fonts/Fact-Expanded.465a41a.woff";